import { get, post } from '@/request/request'

export default {
    list(params) {
        return get('/admin/customer/followup/list', params)
    },
    save(params) {
        return post('/admin/customer/followup/save',params)
    },
    delete(params) {
        return post('/admin/customer/followup/delete', params)
    }

}